import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule} from '@angular/material/button';

import { ListingModule } from '../listing/listing.module';
import { DirectivesModule } from '../../directives/directive.module';
import { VarModule } from '../../directives/ngVar';
import { EditCalendarEventDialog } from './edit-calendar-event-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatSliderModule} from '@angular/material/slider';
import {MatChipsModule} from '@angular/material/chips';

@NgModule({
  declarations: [
    EditCalendarEventDialog
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatChipsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSliderModule,
    MatTableModule,
    ListingModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    DirectivesModule,
    ReactiveFormsModule,
    VarModule
  ],
  exports: [
    EditCalendarEventDialog
  ]
})
export class EditCalendarEventDialogModule {}
